<template>
  <div class="row">
    <div class="col-md-12 text-right">
      <paypal-checkout
        :amount="importe.toString()"
        currency="EUR"
        :client="credentials"
        env="sandbox"
        :button-style="myStyle"
        v-on:payment-authorized="paymentAuthorized"
        v-on:payment-completed="paymentCompleted"
        v-on:payment-cancelled="paymentCancelled"
      ></paypal-checkout>
    </div>
  </div>
</template>

<script>
import paypalCheckout from "vue-paypal-checkout";
export default {
  name: "ins-pasarela-paypal-comp",
  props: ["datos", "importe"],
  components: {
    paypalCheckout
  },
  data: () => ({
    credentials: {
      sandbox:
        "AdECEGIaZVk29ii_crfrII-k4Nj16hO0BXk8IC7kJ0GTXJiTs4LSRZoknsboVN2xTsFzsMBZ9EuYBFbt",
      production: ""
    },
    myStyle: {
      label: "checkout",
      size: "large",
      shape: "rect",
      color: "blue"
    },
    experienceOptions: {
      input_fields: {
        no_shipping: 1
      }
    }
  }),
    methods: {
    paymentAuthorized: function(data) {
      console.log("pago no autorizado", data);
    },
    paymentCompleted: function(data) {
      console.log("pago completado", data);
    },
    paymentCancelled: function(data) {

      console.log("pago cancelado", data);
    }
  }
};
</script>

<style scoped>
</style>